import { Equipment } from 'fitbeat.models';
import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';
import BandCollection from './BandCollection';

interface IProps {
  equipment: Equipment;
  t(key: string, args?: {key: string}): string;
}

const translationArguments = {
  [Equipment.Dumbbells]: {
    equipmentDescription : {equipmentDescription :'dumbbell'},
    itemTypeDescription: {itemTypeDescription: 'weight'},
  },
  [Equipment.UniversalBands]: {
    equipmentDescription : {equipmentDescription: 'Uni-band'},
    itemTypeDescription: {itemTypeDescription: 'band'},
  },
};

const ExplainAssessment: React.FC<IProps> = ({ t, equipment }) => {
  const translationArgs = translationArguments[equipment];
  const imageSrc =
    equipment === Equipment.Dumbbells
      ? require('../assets/images/dumbbellAssessment.png')
      : require('../assets/images/bench-press-with-uni-bands-full.png');
  const imageResizeMode = equipment === Equipment.Dumbbells ? 'cover' : 'contain';
  const showBands = equipment === Equipment.UniversalBands;
  return (
    <View style={styles.container}>
      <View style={styles.imageAndBandContainer}>
        <View style={styles.imageContainer}>
          <Image
            source={imageSrc}
            style={styles.image}
            resizeMode={imageResizeMode}
          />
          {showBands && (
            <View style={styles.banCollection}>
              <BandCollection />
            </View>
          )}
        </View>
      </View>
      <View style={styles.textContainer}>
        <View>
          <Text style={styles.introText}>
            <Text style={styles.regBulletText}>
              {t('explainAssessment_1', translationArgs.equipmentDescription)}
            </Text>
            <Text style={styles.boldBulletText}>
              {t('explainAssessment_2')}
            </Text>
            <Text style={styles.regBulletText}>
              {t('explainAssessment_3', translationArgs.equipmentDescription)}
            </Text>
            <Text style={styles.boldBulletText}>
              {t('explainAssessment_4')}
            </Text>
            <Text style={styles.regBulletText}>{t('explainAssessment_5')}</Text>
            <Text style={styles.boldBulletText}>
              {t('explainAssessment_6')}
            </Text>
          </Text>
        </View>
        <View style={styles.bulletPointContainer}>
          <Text style={styles.bulletPoint}>1.</Text>
          <Text>
            <Text style={styles.boldBulletText}>
              {t('explainStrengthAssessmentPointOne_1')}
            </Text>
            <Text style={styles.regBulletText}>
              {t(
                'explainStrengthAssessmentPointOne_2',
                translationArgs.equipmentDescription,
              )}
            </Text>
          </Text>
        </View>
        <View style={styles.bulletPointContainer}>
          <Text style={styles.bulletPoint}>2.</Text>
          <Text>
            <Text style={styles.boldBulletText}>
              {t('explainStrengthAssessmentPointTwo_1')}
            </Text>
            <Text style={styles.regBulletText}>
              {t(
                'explainStrengthAssessmentPointTwo_2',
                translationArgs.equipmentDescription,
              )}
            </Text>
            <Text style={styles.boldBulletText}>
              {t(
                'explainStrengthAssessmentPointTwo_3',
                translationArgs.itemTypeDescription,
              )}
            </Text>
          </Text>
        </View>
        <View style={styles.bulletPointContainer}>
          <Text style={styles.bulletPoint}>3.</Text>
          <Text>
            <Text style={styles.regBulletText}>
              {t('explainStrengthAssessmentPointThree_1')}
            </Text>
            <Text style={styles.boldBulletText}>
              {t('explainStrengthAssessmentPointThree_2')}
            </Text>
          </Text>
        </View>
        <View style={styles.bulletPointContainer}>
          <Text style={styles.bulletPoint}>4.</Text>
          <Text>
            <Text style={styles.regBulletText}>
              {t('explainStrengthAssessmentPointFour_1')}
            </Text>
            <Text style={styles.boldBulletText}>
              {t('explainStrengthAssessmentPointFour_2')}
            </Text>
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ExplainAssessment;

const styles = StyleSheet.create({
  container: {
    paddingVertical: defaultScale(10),
    flex: 1,
  },
  imageContainer: {
    flex: 1,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  regBulletText: { ...theme.textStyle.bodyCopyReg },
  boldBulletText: { ...theme.textStyle.bodyCopyBold },
  bulletPoint: {
    ...theme.textStyle.bodyCopyReg,
  },
  bulletPointContainer: {
    flexDirection: 'row',
    marginVertical: defaultScale(2),
  },
  textContainer: {
    paddingHorizontal: defaultScale(20),
  },
  introText: {
    marginVertical: defaultScale(10),
  },
  imageAndBandContainer: {
    position: 'relative',
    flex: 1,
  },
  banCollection: {
    position: 'absolute',
    top: '25%',
    right: '7%',
  },
});
